// extracted by mini-css-extract-plugin
export var cardWrapper = "_54-0";